import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const OrgManagementModule = React.lazy(() => import("./OrgManagementModule"));
const MembersPage = React.lazy(() => import("./pages/MembersPage/MembersPage"));
const TransactionsPage = React.lazy(() => import("./pages/TransactionsPage/TransactionsPage"));
const SecurityPage = React.lazy(() => import("./pages/SecurityPage/SecurityPage"));
const ClientSettingsPage = React.lazy(() => import("./pages/ClientSettingsPage/ClientSettingsPage"));
const OrgOverviewPage = React.lazy(() => import("./pages/OrgOverviewPage/OrgOverviewPage"));
const AdminDashboardPage = React.lazy(() => import("./pages/AdminDashboardPage/AdminDashboardPage"));
const OrgProjectGroupsPage = React.lazy(() => import("./pages/OrgProjectGroupsPage/OrgProjectGroupsPage"));

export const OrgManagementModuleRoutes: RouteObject = {
  path: ":clientId/manage-org/*",
  element: (
    <ModuleRoute El={OrgManagementModule} moduleName="org-management" inPolicy="SharedViewerOrgAdmin" />
  ),
  children: [
    {
      path: "admin-dashboard",
      element: <PageRoute El={AdminDashboardPage} />,
    },
    {
      path: "overview",
      element: <PageRoute El={OrgOverviewPage} />,
    },
    {
      path: "members",
      element: <PageRoute El={MembersPage} />,
    },
    {
      path: "transactions/:tab?",
      element: <PageRoute El={TransactionsPage} />,
    },
    {
      path: "security",
      element: <PageRoute El={SecurityPage} />,
    },
    {
      path: "settings",
      element: <PageRoute El={ClientSettingsPage} ff="ProjectNarratives" />,
    },
    {
      path: "groups",
      element: <PageRoute El={OrgProjectGroupsPage} />,
    },
    {
      path: "",
      element: <Navigate to={"admin-dashboard"} />,
    },
  ],
};
